/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { Location } from '@angular/common'

import { FeatureToggleHelperService } from './feature-toggle-helper.service'
import { FeatureToggles } from '../configuration/config.interface'
import { ConfigService } from '../configuration/config.service'
import { FeatureToggle } from '../feature-toggles.defintions'
import { environment } from '../../../environments/environment'

export abstract class FeatureToggleEnum {
  [key: string]: string
}

export abstract class FeatureToggleConfig {
  featureToggleEnum?: FeatureToggleEnum
}

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  private configService = inject(ConfigService)
  private location = inject(Location)
  private featureToggleHelperService = inject(FeatureToggleHelperService)

  private featureToggles: FeatureToggles = {
    enabled: [],
    disabled: [],
  }

  initialize(fragment: string): void {
    const featureToggleEnum = FeatureToggle
    this.featureToggles = this.mergeEnvironmentDefaults(this.configService.getFeatureToggles())
    const assignmentHalvesSet = this.featureToggleHelperService.getAssignmentHalves(fragment)

    this.featureToggles = this.featureToggleHelperService.updateFeatureToggles(this.featureToggles, featureToggleEnum, assignmentHalvesSet)
  }

  private mergeEnvironmentDefaults(configToggles: FeatureToggles): FeatureToggles {
    const environmentEnabled: string[] = environment.featureToggles?.enabled ?? []
    const enabled = [...(configToggles?.enabled ?? [])]

    environmentEnabled.forEach((toggle) => {
      if (!enabled.includes(toggle)) {
        enabled.push(toggle)
      }
    })

    return {
      enabled,
      disabled: configToggles?.disabled ?? [],
    }
  }

  isFeatureEnabled<T, U>(featureToggle: string, disabled?: T, enabled?: U, invert?: boolean): T | U
  isFeatureEnabled(featureToggle: string, disabled = false, enabled = true, invert = false): boolean {
    return this.featureToggleHelperService.isFeatureEnabled(this.featureToggles, featureToggle, disabled, enabled, invert)
  }
}
